export default "__VITE_ASSET__DpX2yWcc__"